import { BehaviorSubject, Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { StorageService } from '@coin-depo-core/storage';

import type { User } from '@coin-depo-types';

export class UserProfileInfo {
  private dataSubject = new BehaviorSubject<Partial<User> | null>(null);
  private loadedSubject = new BehaviorSubject<boolean>(false);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  data$ = this.dataSubject;
  sData$: Observable<Partial<User> | null> = this.dataSubject.asObservable().pipe(shareReplay(1));
  sLoaded$: Observable<boolean> = this.loadedSubject.asObservable().pipe(shareReplay(1));
  sLoading$: Observable<boolean> = this.loadingSubject.asObservable().pipe(shareReplay(1));

  constructor(private storage: StorageService) {}

  load(): void {
    this.loadingSubject.next(true);

    const user = this.storage.get('userData');

    if (user) {
      this.dataSubject.next(user);
      this.loadedSubject.next(true);
    } else {
      this.dataSubject.next(null);
      this.loadedSubject.next(false);
    }

    this.loadingSubject.next(false);
  }

  clear(): void {
    this.dataSubject.next(null);
    this.loadedSubject.next(false);
    this.loadingSubject.next(false);
  }

  getValue(): Partial<User> | null {
    return this.dataSubject.getValue();
  }
}